import React from "react";

import type { Mandate } from "../../../../../shared/domains/mandates/mandate";
import { ACTIVATE_MANDATE_MODAL_ID } from "../../../../core/modal/modal-id";
import { MandateModal } from "./mandate-modal";

export interface ActivateMandateModalProps {
  mandate: Mandate;
  onConfirm: () => void;
}

export const ActivateMandateModal = (props: ActivateMandateModalProps) => {
  const { mandate, onConfirm } = props;

  return (
    <MandateModal
      mandate={mandate}
      onConfirm={onConfirm}
      modalId={ACTIVATE_MANDATE_MODAL_ID}
      textPrompt={"mandates.activatePrompt"}
    />
  );
};
